// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "VariableLocalisation" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { OrganisationGenShape } from "./organisation.gen";

export const VariableLocalisationGenShape = z.strictObject({
  libraryId: z.string(),
  parentId: z.string(),
  teamId: z.string(),
  value: z.string().optional(),
  organisations: z.array(OrganisationGenShape).optional(),
  skipped: z.boolean().optional(),
  id: z.string(),
});
